import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../utility/Button';
import PriceSummary from './PriceSummary';
import CoverPhoto from '../utility/CoverPhoto';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import Cookies from 'js-cookie';
import { formatDate, mailto, lastOf } from '../../js/utility';
import { Auth } from 'aws-amplify';
import { withTranslation } from 'react-i18next';
import { SDAC_EMAIL } from '../../constants';
import { productCheckoutGA } from '../../js/analytics';
import TagManager from 'react-gtm-module';

import {
  setBookingStep,
  fetchPricingInfo,
  postBookingForm,
  toggleProceedToPayment,
  toggleAgreeCancellationPolicy,
  setBookingPrice,
  postBookingFormWithAuth
} from '../../actions/booking';

import { calcSimplePrice } from '../../js/utility';

import { clearApiError } from '../../actions/api';

class BookingConfirmation extends Component {
  constructor(props) {
    super(props);
    this.cpBox = React.createRef();
    this.state = {
      cpBoxActivated: false,
      showPromoPopup: false
    };
    this.agreeCancellationPolicy = false;
    this.handleCancellationPolicyCheckbox = this.handleCancellationPolicyCheckbox.bind(
      this
    );
    this.togglePromoPopup = this.togglePromoPopup.bind(this);
    this.goBack = this.goBack.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    this.props.toggleAgreeCancellationPolicy(false);
    this._isMounted = true;
    const { clearApiError } = this.props;
    clearApiError();
  }

  componentWillUnmount() {
    this.props.toggleAgreeCancellationPolicy(false);
    this._isMounted = false;
  }

  handleCancellationPolicyCheckbox() {
    const {bookingPrice} = this.props;
    let newestPromo = {};

    if (bookingPrice.promos) {
      newestPromo = lastOf(bookingPrice.promos) ? ((lastOf(bookingPrice.promos).promoCode === 'TRUE') ? {} : lastOf(bookingPrice.promos)) : {};
    }

    if (!this.state.cpBoxActivated) {
      this.setState({
        cpBoxActivated: true
      });
    }

    if (!this.props.agreeCancellationPolicy){
      if (this.props.currentTrip.promocode && !newestPromo.promoValid){
        this.togglePromoPopup();
      }
    }

    this.props.toggleAgreeCancellationPolicy(
      !this.props.agreeCancellationPolicy
    );
  }

  togglePromoPopup() {
    this.setState({showPromoPopup: !this.state.showPromoPopup});
  }

  goBack() {
    //Reset backend pricing to frontend pricing before going back to step 1
    const { bookingInfo, bookingPax, setBookingPrice, slug, bookingDate, isByPax, byorIsMember, fetchPricingInfo} = this.props;
    setBookingPrice(calcSimplePrice(bookingInfo, bookingPax));
    this.props.setBookingStep(2);
    fetchPricingInfo(
      slug,
      bookingPax,
      '',
      null,
      isByPax,
      byorIsMember,
      bookingDate
    );
  }

  async submitForm() {
    const {
      data,
      pax,
      isByPax,
      date,
      // selectedVehicleId,
      // selectedMeetingPointId,
      isDriver,
      postBookingForm,
      postBookingFormWithAuth,
      match,
      toggleProceedToPayment,
      agreeCancellationPolicy,
      bookingPrice,
      saveUuid,
      bookingInfo,
      byorIsMember,
      byorVehicleNo,
      vehicleModel,
      slug
    } = this.props;

    const mobPrefix = '+60';
    const isRaptorEvent = slug === "a-desaru-fruit-farm-resort-staycation" || slug === "raptor-rev";

    const byorRegisNum = byorVehicleNo.replace(/ /g, '');

    let byorStatus;
    if (vehicleModel.length) {
      byorStatus = true;
    } else if (byorIsMember == null) {
      byorStatus = false;
    } else if (byorIsMember == false) {
      byorStatus = false;
    } else {
      byorStatus = true;
    }

    let companionArray = [];
    let companionNameArray = [];
    let companionIcArray = [];
    let companionEmailArray = [];
    let companionHealthArray = [];
    let companionSizeArray = [];
    let companionTshirtNameArray = [];

    for (let x=0; x<4; x++){
      if (data['companionName'+x] !== ''){
        companionNameArray.push(data['companionName'+x]);
      }
      if (data['companionIc'+x] !== ''){
        companionIcArray.push(data['companionIc'+x]);
      }

      companionEmailArray.push((data['companionEmail'+x] !== '') ? data['companionEmail'+x] : null);
      companionHealthArray.push((data['companionHealth'+x] !== '') ? data['companionHealth'+x] : null);
      companionSizeArray.push((isRaptorEvent) ? data['companionSize'+x] : null);
      companionTshirtNameArray.push((data['companionTshirtName'+x] !== '') ? data['companionTshirtName'+x] : null);
    }

    companionNameArray.forEach((name, index) => {
      const companionIc = companionIcArray.find((ic, idx) => idx === index);
      const companionEmail = companionEmailArray.find((ic, idx) => idx === index);
      const companionHealth = companionHealthArray.find((ic, idx) => idx === index);
      const companionSize = companionSizeArray.find((ic, idx) => idx === index);
      const companionTshirtName = companionTshirtNameArray.find((ic, idx) => idx === index);

      if (companionIc)
        companionArray.push({
          full_name: name,
          ic_no: companionIc,
          email: companionEmail,
          health: companionHealth,
          size: companionSize,
          tshirtName: companionTshirtName
        });
    });

    let formData = {
      personal: {
        full_name: data.name,
        ic_no: data.ic,
        email: data.email,
        mobile_no: mobPrefix.concat(data.mobile),
        is_driver: isDriver,
        experience: isDriver && isRaptorEvent ? data.driver_experience : null,
        health: isDriver && isRaptorEvent && !data.driver_HealthConfirm ? data.driver_health : null,
        size: isDriver && isRaptorEvent ? data.driver_size : null,
        tshirtName: isDriver && data.driver_tshirtName ? data.driver_tshirtName : null
      },
      booking: {
        tnc: data.agreeTnc,
        has_valid_license: data.agreeLicense,
        cancellation_policy: agreeCancellationPolicy,
        pax_no: parseInt(pax),
        // selected_vehicle_id: parseInt(selectedVehicleId),
        // meeting_point_id: parseInt(selectedMeetingPointId),
        promo_code: bookingPrice.promos
          .map(obj => obj.promoValid && obj.promoCode)
          .find(code => !!code),
        byor: byorStatus,
        vehicle_model: vehicleModel,
        is_ranger_owner: (vehicleModel.length === 0),
        registration_no: byorRegisNum,
        tour_date: date
      }
    };

    if (isByPax) {
      formData.booking.pax_no = 0;
      formData.booking.adult = pax.adult ? parseInt(pax.adult) : parseInt(pax);
      formData.booking.child = parseInt(pax.child);
    } else if (typeof pax === 'number') {
      formData.booking.pax_no = parseInt(pax);
      formData.booking.adult = 0;
      formData.booking.child = 0;
    } else {
      formData.booking.pax_no = 0;
      formData.booking.adult = parseInt(pax.adult);
      formData.booking.child = parseInt(pax.child);
    }

    if (companionArray.length) {
      formData = {
        ...formData,
        companion: companionArray
      };
    }

    if (!isDriver) {
      formData = {
        ...formData,
        driver: {
          full_name: data.driver_name,
          ic_no: data.driver_ic,
          mobile_no: mobPrefix.concat(data.driver_mobile),
          email: data.driver_email,
          experience: isRaptorEvent ? data.driver_experience : null,
          health: isRaptorEvent && !data.driver_HealthConfirm ? data.driver_health : null,
          size: isRaptorEvent ? data.driver_size : null,
          tshirtName: data.driver_tshirtName ? data.driver_tshirtName : null,
        }
      };
    }
    if (saveUuid !== '' || match.params.uuid) {
      formData.save_later_uuid = saveUuid !== '' ? saveUuid : match.params.uuid;
    }
    console.log('form data', formData);

    window.scrollTo(0, 0);
    // Send purchase event to Google Analytics
    productCheckoutGA(
      bookingInfo.booking_for,
      bookingInfo.theme,
      parseFloat(bookingPrice.totalPrice),
      bookingPrice.promoCode !== '' ? bookingPrice.promoCode : null
    );
    // Send click event to Google Tag Manager
    TagManager.dataLayer({
      dataLayer: {
        event: 'click-proceed-to-payment'
      }
    });
    toggleProceedToPayment(true);
    await Auth.currentAuthenticatedUser()
      .then(() => {
        postBookingFormWithAuth(
          match.params.slug,
          JSON.stringify(formData),
          decodeURIComponent(Cookies.get('XSRF-TOKEN'))
        );
      })
      .catch(() => {
        postBookingForm(
          match.params.slug,
          JSON.stringify(formData),
          decodeURIComponent(Cookies.get('XSRF-TOKEN'))
        );
      });
  }

  render() {
    const {
      data,
      isDriver,
      bookingInfo,
      bookingDate,
      companions,
      bookingPax,
      selectedVehicleName,
      selectedMeetingPointName,
      bookingPrice,
      promoCode,
      date,
      applyCode,
      handleChange,
      hide,
      loading,
      t,
      agreeCancellationPolicy,
      match,
      slug
    } = this.props;

    let companionArray = [];
    let companionNameArray = [];
    let companionIcArray = [];
    let companionEmailArray = [];
    let companionHealthArray = [];
    let companionSizeArray = [];
    let companionTshirtNameArray = [];

    const isRaptorEvent = slug === "a-desaru-fruit-farm-resort-staycation" || slug === "raptor-rev";

    for (let x=0; x<4; x++){
      if (data['companionName'+x] !== ''){
        companionNameArray.push(data['companionName'+x]);
      }
      if (data['companionIc'+x] !== ''){
        companionIcArray.push(data['companionIc'+x]);
      }

      companionEmailArray.push((data['companionEmail'+x] !== '') ? data['companionEmail'+x] : null);
      companionHealthArray.push((data['companionHealth'+x] !== '') ? data['companionHealth'+x] : null);
      companionSizeArray.push((isRaptorEvent) ? data['companionSize'+x] : null);
      companionTshirtNameArray.push((data['companionTshirtName'+x] !== '') ? data['companionTshirtName'+x] : null);
    }

    companionNameArray.forEach((name, index) => {
      const companionIc = companionIcArray.find((ic, idx) => idx === index);
      const companionEmail = companionEmailArray.find((ic, idx) => idx === index);
      const companionHealth = companionHealthArray.find((ic, idx) => idx === index);
      const companionSize = companionSizeArray.find((ic, idx) => idx === index);
      const companionTshirtName = companionTshirtNameArray.find((ic, idx) => idx === index);

      if (companionIc)
        companionArray.push({
          full_name: name,
          ic_no: companionIc,
          email: companionEmail,
          health: companionHealth,
          size: companionSize,
          tshirtName: companionTshirtName
        });
    });

    const totalPax =
      typeof bookingPax !== 'number'
        ? bookingPax.adult + bookingPax.child
        : bookingPax;

    const mobPrefix = '+60';
    return (
      <div className={`col-lg-8 ${hide ? 'fe-hide' : ''}`}>
        <div className={`fe-overlay ${this.state.showPromoPopup ? '' : 'fe-hide'}`} onClick={() => this.togglePromoPopup()}>
        </div>
        <div className={`fe-promo-popup-container ${this.state.showPromoPopup ? '' : 'fe-hide'}`}>
          <div className='fe-promo-popup-text'>
            <span>There is a promo code available for this experience. Would you like to apply the promo code for this purchase?</span>
          </div>
          <div className='fe-promo-popup-button-group'>
            <Button className='fe-btn-apply' onClick={() => {this.togglePromoPopup(); this.props.promoPopupConfirm(this.props.currentTrip.promocode);}}>
              Yes, apply promo code
            </Button>
            <Button alt onClick={() => this.togglePromoPopup()}>
              No, proceed to payment
            </Button>
          </div>
        </div>
        <section className='fe-booking-confirmation'>
          <h3 className='fe-booking-title'>{t('form:bookingConfirmation')}</h3>
          <CoverPhoto
            mobileUrl={bookingInfo.photo_cover.mobile_view}
            desktopUrl={bookingInfo.photo_cover.desktop_view}
          />
          <p>{t('form:bookingConfirmText')}</p>
          <section className='fe-booking-confirm-details-container mobile'>
            <h4 className='fe-booking-title'>{t('form:bookingSummary')}</h4>
            <div className='fe-booking-confirm-details'>
              <div className='fe-booking-confirm-info'>
                <div className='fe-booking-confirm-info-title'>
                  {
                    (match.params.slug === 'a-desaru-fruit-farm-resort-staycation' || match.params.slug === "raptor-rev")? 
                    (t('form:event'))
                    :
                    (t('form:getaway'))
                  }
                </div>
                <div className='fe-booking-confirm-content'>
                  {bookingInfo.booking_for}
                </div>
              </div>
              <div className='fe-booking-confirm-info'>
                <div className='fe-booking-confirm-info-title'>
                  {
                    (match.params.slug === 'a-desaru-fruit-farm-resort-staycation' || match.params.slug === "raptor-rev")? 
                    (t('form:getawayDate'))
                    :
                    (t('form:getawayTravelDate'))
                  }
                </div>
                <div className='fe-booking-confirm-content'>
                  {formatDate(bookingDate)}
                </div>
              </div>
              <div className='fe-booking-confirm-info'>
                <div className='fe-booking-confirm-info-title'>
                  {t('form:numPax')}
                </div>
                <div className='fe-booking-confirm-content'>{totalPax}</div>
              </div>
              {/* <div className='fe-booking-confirm-info'>
                <div className='fe-booking-confirm-info-title'>
                  {t('form:vehicleSelection')}
                </div>
                <div className='fe-booking-confirm-content'>
                  {selectedVehicleName}
                </div>
              </div> */}
              {/* <div className='fe-booking-confirm-info'>
                <div className='fe-booking-confirm-info-title'>
                  {t('form:meetingPoint')}
                </div>
                <div className='fe-booking-confirm-content'>
                  {selectedMeetingPointName}
                </div>
              </div> */}
            </div>
          </section>
          <section className='fe-booking-confirm-details-container'>
            <h4 className='fe-booking-title'>{t('form:personalDetails')}</h4>
            <div className='fe-booking-confirm-details'>
              <div className='fe-booking-confirm-info'>
                <div className='fe-booking-confirm-info-title'>
                  {t('form:fullNameAsIC')}
                </div>
                <div className='fe-booking-confirm-content'>{data.name}</div>
              </div>
              <div className='fe-booking-confirm-info'>
                <div className='fe-booking-confirm-info-title'>
                  {t('form:email')}
                </div>
                <div className='fe-booking-confirm-content'>{data.email}</div>
              </div>
              <div className='fe-booking-confirm-info'>
                <div className='fe-booking-confirm-info-title'>
                  {t('form:icNo')}
                </div>
                <div className='fe-booking-confirm-content'>{data.ic}</div>
              </div>
              <div className='fe-booking-confirm-info'>
                <div className='fe-booking-confirm-info-title'>
                  {t('form:mobileNo')}
                </div>
                <div className='fe-booking-confirm-content'>{`${mobPrefix} ${data.mobile}`}</div>
              </div>
              {isDriver && isRaptorEvent && (
                <>
                  <div className='fe-booking-confirm-info'>
                    <div className='fe-booking-confirm-info-title'>
                      {t('form:offRoadExperience')}
                    </div>
                    <div className='fe-booking-confirm-content'>{data.driver_experience}</div>
                  </div>
                  <div className='fe-booking-confirm-info'>
                    <div className='fe-booking-confirm-info-title'>
                      {t('form:tShirtSize')}
                    </div>
                    <div className='fe-booking-confirm-content'>{data.driver_size}</div>
                  </div>
                  <div className='fe-booking-confirm-info'>
                    <div className='fe-booking-confirm-info-title'>
                      {t('form:tshirtName')}
                    </div>
                    <div className='fe-booking-confirm-content'>{data.driver_tshirtName}</div>
                  </div>
                  <div className='fe-booking-confirm-info'>
                    <div className='fe-booking-confirm-info-title'>
                      {t('form:healthDeclaration')}
                    </div>
                    <div className='fe-booking-confirm-content'>{data.driver_health || '-'}</div>
                  </div>
                </>
              )}
            </div>
          </section>
          {!isDriver ? (
            <section className='fe-booking-confirm-details-container'>
              <h4 className='fe-booking-title'>{t('form:driverDetails')}</h4>
              <div className='fe-booking-confirm-details'>
                <div className='fe-booking-confirm-info'>
                  <div className='fe-booking-confirm-info-title'>
                    {t('form:fullNameAsIC')}
                  </div>
                  <div className='fe-booking-confirm-content'>
                    {data.driver_name}
                  </div>
                </div>
                <div className='fe-booking-confirm-info'>
                  <div className='fe-booking-confirm-info-title'>
                    {t('form:icNo')}
                  </div>
                  <div className='fe-booking-confirm-content'>
                    {data.driver_ic}
                  </div>
                </div>
                <div className='fe-booking-confirm-info'>
                  <div className='fe-booking-confirm-info-title'>
                    {t('form:mobileNo')}
                  </div>
                  <div className='fe-booking-confirm-content'>{`${mobPrefix} ${data.driver_mobile}`}</div>
                </div>
                <div className='fe-booking-confirm-info'>
                  <div className='fe-booking-confirm-info-title'>
                    {t('form:email')}
                  </div>
                  <div className='fe-booking-confirm-content'>{data.driver_email}</div>
                </div>
                {isRaptorEvent && (
                  <>
                    <div className='fe-booking-confirm-info'>
                      <div className='fe-booking-confirm-info-title'>
                        {t('form:offRoadExperience')}
                      </div>
                      <div className='fe-booking-confirm-content'>{data.driver_experience}</div>
                    </div>
                    <div className='fe-booking-confirm-info'>
                      <div className='fe-booking-confirm-info-title'>
                        {t('form:tShirtSize')}
                      </div>
                      <div className='fe-booking-confirm-content'>{data.driver_size}</div>
                    </div>
                    <div className='fe-booking-confirm-info'>
                      <div className='fe-booking-confirm-info-title'>
                        {t('form:tshirtName')}
                      </div>
                      <div className='fe-booking-confirm-content'>{data.driver_tshirtName}</div>
                    </div>
                    <div className='fe-booking-confirm-info'>
                      <div className='fe-booking-confirm-info-title'>
                        {t('form:healthDeclaration')}
                      </div>
                      <div className='fe-booking-confirm-content'>{data.driver_health || '-'}</div>
                    </div>
                  </>
                )}
              </div>
            </section>
          ) : null}

          {companionArray.map((companion, idx) => {
            return (
              <section key={idx} className='fe-booking-confirm-details-container'>
                <h4 className='fe-booking-title'>{t('gen:companion') + ' ' + (idx+1)}</h4>
                <div className='fe-booking-confirm-details'>
                  <div className='fe-booking-confirm-info'>
                    <div className='fe-booking-confirm-info-title'>
                      {t('form:fullNameAsIC')}
                    </div>
                    <div className='fe-booking-confirm-content'>
                      {companion.full_name}
                    </div>
                  </div>
                  <div className='fe-booking-confirm-info'>
                    <div className='fe-booking-confirm-info-title'>
                      {t('form:icNo')}
                    </div>
                    <div className='fe-booking-confirm-content'>
                      {companion.ic_no}
                    </div>
                  </div>
                  <div className='fe-booking-confirm-info'>
                    <div className='fe-booking-confirm-info-title'>
                      {t('form:email')}
                    </div>
                    <div className='fe-booking-confirm-content'>{companion.email || '-'}</div>
                  </div>
                  {isRaptorEvent && (
                    <>
                      <div className='fe-booking-confirm-info'>
                        <div className='fe-booking-confirm-info-title'>
                          {t('form:tShirtSize')}
                        </div>
                        <div className='fe-booking-confirm-content'>{companion.size}</div>
                      </div>
                      <div className='fe-booking-confirm-info'>
                        <div className='fe-booking-confirm-info-title'>
                          {t('form:tshirtName')}
                        </div>
                        <div className='fe-booking-confirm-content'>{companion.tshirtName}</div>
                      </div>
                      <div className='fe-booking-confirm-info'>
                        <div className='fe-booking-confirm-info-title'>
                          {t('form:healthDeclaration')}
                        </div>
                        <div className='fe-booking-confirm-content'>{companion.health || '-'}</div>
                      </div>
                    </>
                  )}
                </div>
              </section>
            );
          })}
          <section className='fe-booking-confirm-price-summary'>
            <PriceSummary
              isLoading={loading}
              applyCode={applyCode}
              promoCode={promoCode}
              handleChange={handleChange}
            />
          </section>
          <div
            className='fe-booking-confirm-warning'
            dangerouslySetInnerHTML={{
              __html: mailto(SDAC_EMAIL, t('form:noCancel'))
            }}
          />
          <div className='fe-form-checkboxes'>
            <label className='fe-form-checkbox-container'>
              <input
                ref={this.cpBox}
                type='checkbox'
                name='agreeCancellationPolicy'
                checked={agreeCancellationPolicy}
                onChange={this.handleCancellationPolicyCheckbox}
              />
              <span className='fe-form-checkbox' />
              {t('form:cancellationPolicyCheckbox')}
            </label>
          </div>
          <div className='fe-booking-confirm-controls'>
            <Button
              disabled={!agreeCancellationPolicy}
              showLoader={false}
              onClick={this.submitForm}
            >
              {parseFloat(bookingPrice.total) === 0
                ? t('form:completeBooking')
                : t('form:proceedToPay')}
            </Button>
            <Button onClick={this.goBack}>
              {t('form:editBooking')}
            </Button>
          </div>
          {!agreeCancellationPolicy ? (
            <span className='fe-form-error'>
              {t('form:cancellationPolicyError')}
            </span>
          ) : (
            ''
          )}
        </section>
      </div>
    );
  }
}

BookingConfirmation.propTypes = {
  bookingInfo: PropTypes.object.isRequired,
  date: PropTypes.string.isRequired,
  pax: PropTypes.oneOfType([PropTypes.number, PropTypes.object]).isRequired,
  data: PropTypes.object.isRequired,
  isDriver: PropTypes.bool.isRequired,
  setBookingStep: PropTypes.func.isRequired,
  postBookingForm: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  hide: PropTypes.bool.isRequired,
  toggleProceedToPayment: PropTypes.func.isRequired,
  fetchPricingInfo: PropTypes.func.isRequired,
  clearApiError: PropTypes.func.isRequired,
  promoCode: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  applyCode: PropTypes.func.isRequired,
  selectedVehicleName: PropTypes.string.isRequired,
  selectedMeetingPointName: PropTypes.string.isRequired,
  // selectedVehicleId: PropTypes.number.isRequired,
  // selectedMeetingPointId: PropTypes.number.isRequired,
  bookingPax: PropTypes.oneOfType([PropTypes.number, PropTypes.object])
    .isRequired,
  setBookingPrice: PropTypes.func.isRequired,
  bookingPrice: PropTypes.object.isRequired,
  bookingDate: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  postBookingFormWithAuth: PropTypes.func.isRequired,
  saveUuid: PropTypes.string,
  agreeCancellationPolicy: PropTypes.bool.isRequired,
  toggleAgreeCancellationPolicy: PropTypes.func.isRequired,
  byorIsMember: PropTypes.bool,
  byorVehicleNo: PropTypes.string,
  vehicleModel: PropTypes.string,
  currentTrip: PropTypes.object.isRequired,
  promoPopupConfirm: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
  isByPax: PropTypes.bool
};

const mapStateToProps = ({ bookingState, tripDetailsState }) => ({
  bookingInfo: bookingState.bookingInfo,
  date: bookingState.date,
  pax: bookingState.pax,
  isByPax: bookingState.bookingInfo.isByPax,
  data: bookingState.formData,
  isDriver: bookingState.primaryDriver,
  bookingDate: bookingState.date,
  bookingPax: bookingState.pax,
  bookingPrice: bookingState.bookingPrice,
  selectedVehicleName: bookingState.selectedVehicleName,
  // selectedVehicleId: bookingState.selectedVehicleId,
  // selectedMeetingPointId: bookingState.selectedMeetingPointId,
  selectedMeetingPointName: bookingState.selectedMeetingPointName,
  loading: bookingState.loading,
  saveUuid: bookingState.saveUuid,
  agreeCancellationPolicy: bookingState.agreeCancellationPolicy,
  byorIsMember: bookingState.byorIsMember,
  byorVehicleNo: bookingState.byorVehicleNo,
  vehicleModel: bookingState.vehicleModel,
  currentTrip: tripDetailsState.currentTrip
});

const mapDispatchToProps = {
  setBookingStep,
  fetchPricingInfo,
  postBookingForm,
  toggleProceedToPayment,
  toggleAgreeCancellationPolicy,
  setBookingPrice,
  clearApiError,
  postBookingFormWithAuth
};

export default withRouter(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(BookingConfirmation)
  )
);
